import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {QuestionFlowSessionQuery} from '../state/question-flow-session.query';
import {Question} from '../../models/underwriter.model';
import {AuthenticationService} from '../../../authentication/service/authentication.service';
import {UserStore} from '../../../authentication/state/user.store';
import {newGuid, getParam} from '../question-helper';
import {API_PATH, RouterLinks} from '../../constants';
import {GlobalQuestionService} from '../../services/global-question.service';
import {Router} from '@angular/router';
import { ComponentsService } from '../../services/components-service';
import { NgxCurrencyConfig, NgxCurrencyInputMode } from 'ngx-currency';

declare const $: any;
declare const Dropzone: any;
declare const dropzonePreviewTemplate: any;

@Component({
    selector: 'app-question-funeral-policy-member',
    templateUrl: './question-funeral-policy-member.component.html',
    styleUrls: ['./question-funeral-policy-member.component.scss'],
    standalone: false
})
export class QuestionFuneralPolicyMemberComponent implements OnInit {

  session_details: any;
  note = '';
  dropZone: any;
  acceptedFileTypes = 'image/*';
  fileSelectorEl = `question-note-uploader-${newGuid()}`;
  savedResources: any[] = [];
  buttonDisabled = true;
  @Input() question: any;
  @Input() childItemQuestions: any[] = [];
  @Output() noteChanged = new EventEmitter<Question>();
  @Output() questionAnswer = new EventEmitter<any>();
  questions: any;
  edit = false;
  members: any[] = [];
  item_id = 0;
  firstname = '';
  lastname = '';
  dob = '';
  age = 0;
  relationships: any;
  cover = 0;
  coverOptions: any[] = [];
  filteredOptions: any[] = [];
  policyHolderSI = 0;
  selectedOption = 0;
  maskOptions: NgxCurrencyConfig;
  constructor(
    private questionSession: QuestionFlowSessionQuery,
    private authService: AuthenticationService,
    private userStore: UserStore,
    private componentsService: ComponentsService,
    private questionService: GlobalQuestionService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.session_details = this.questionSession.getValue();
    if (this.question?.parameter) {
        let parameters = JSON.parse(this.question?.parameter);
        const policyholderSiParam = getParam(parameters, 'policyholder_si');
        const currencyParam = getParam(parameters, 'currency');

        if (policyholderSiParam){
          this.questionService.getResponse(policyholderSiParam.value).subscribe(res => {
            this.policyHolderSI = res[0]?.answer;
          })
        }
         if (currencyParam) {
                  this.maskOptions = {
                    max: null,
                    min: 0,
                    allowZero: true,
                    nullable: false,
                    inputMode: NgxCurrencyInputMode.Natural,
                    align: 'left',
                    allowNegative: false,
                    prefix: currencyParam?.value,
                    decimal: '.',
                    suffix: '',
                    thousands: ' ',
                    precision: 0
                  };
                } else {
                  this.maskOptions = {
                    max: null,
                    min: 0,
                    allowZero: true,
                    nullable: false,
                    align: 'right',
                    allowNegative: false,
                    prefix: '',
                    decimal: '.',
                    suffix: '',
                    thousands: ' ',
                    precision: 0
                  };
                }
    }
    
  }
  ngAfterViewInit(): void{
   //this.getPolicyMembers();
   this.getChildrenQuestion();
   this.getFuneralCoverOptions();
   this.getFuneralRelations();
   
  }
  getPolicyMembers(): void {
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.session_details?.session_id);
    this.questionService.runCommandNew(`getPolicyMembers`, parameters)
      .subscribe((questions: any[]) => {
        console.log(questions);
        //this.questions = questions;
        type QuestionItem = {
          item_id: string;
          answer: string;
          [key: string]: any;
        };

        const data: QuestionItem[] = questions;

        const grouped: Record<string, QuestionItem[]> = {};

        for (const item of data) {
          const key = `${item.item_id}_${item.answer}`;
          if (!grouped[key]) {
            grouped[key] = [];
          }
          grouped[key].push(item);
        }

      })
  }
  getFuneralRelations(): void {
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.session_details?.session_id);
    this.questionService.runCommandNew(`getFuneralRelations`, parameters)
      .subscribe((relationships: any[]) => {
        this.relationships = relationships;
      })
  }
  getFuneralCoverOptions(): void {
    const parameters = new Map<string, string>();
    this.questionService.runCommandNew(`getFuneralCoverOptions`, parameters)
      .subscribe((coverOptions: any[]) => {
        this.coverOptions = coverOptions;
      })
  }
  getChildrenQuestion(): void {
    this.questionService.spinner(true);

    // const parameters = new Map<string, string>();
    // this.questionService.runCommandNew(`getFuneralMemberQuestions`, parameters)
    //   .subscribe((questions: any[]) => {
    //     console.log(questions);
    //     //this.questions = questions;
    //     this.questions = [];
    //     for (const q of questions) {
    //       if (!this.questions.some(c => c.cent_aq_question_id === q.cent_aq_question_id)) {
    //         q.item_id = this.question.item_id;
    //         this.questions.push(Object.assign({}, q));
    //       }
    //     }
    //     this.questionService.spinner(false);
    //   })

    if (this.childItemQuestions.length === 0){
    this.questionService.getChildrenQuestions(this.question?.cent_aq_question_id)
      .subscribe((items: Question[]) => {
        //console.log(items)
        this.questions = [];
        for (const q of items) {
          if (!this.questions.some(c => c.cent_aq_question_id === q.cent_aq_question_id) && q.item_id === this.question.item_id) {
            this.questions.push(Object.assign({}, q));
          }
        }
        //console.log(this.questions);
        this.questionService.spinner(false);
        // if (this.members.length === 0){
        //   let member = {
        //     item_id: this.item_id++,
        //     name: 'Add member',
        //     questions: this.questions
        //   }
        //   this.members.push(member);
          
        // }
      });
    }
    else {
      this.questions = this.childItemQuestions;
      this.questionService.spinner(false);
    }
  }
  getQuestion(id: number): any {
    return this.questions.filter(q => q.cent_aq_question_id === id)[0];
  }
  showModal(question: Question): void {
    this.note = '';
    this.savedResources = [];
    this.buttonDisabled = true;
    this.question = question;
    if (this.question?.comment) {
      this.note = this.question?.comment;
      this.buttonDisabled = false;
    }
    /*if (this.dropZone) {
      this.dropZone?.destroy();
    }
    this.refreshToken();*/
    $('#question-add-note__modal').modal('show');
  }

  refreshToken(): void {
    this.authService.refreshToken()
      .subscribe(x => {
        this.userStore.update({
          access_token: x?.access_token,
          refresh_token: x?.refresh_token
        });
        this.initDropzone(x?.access_token);
      });
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
    this.questions = changes?.childItemQuestions.currentValue;
    setTimeout(() => {
      //this.selectedCover = this.getQuestion(2508)?.answer;
      this.setCoverOptions(this.getQuestion(2507));
   }, 1000);
    
  }
  onChange(event:any,index: any): void {
    
    if (this.questions.every(q => q.answer) ) {
      this.buttonDisabled = null;
      console.log(this.item_id,this.questions);
      const Questions = JSON.parse(JSON.stringify(this.questions));
      let member = {
        item_id: this.item_id++,
        name: Questions[0]?.answer,
        questions: Questions
      }
      this.members.push(member);
      this.questions.forEach(q => {
        q.answer = ""; // Sets the answer to an empty string for each question
      });
      console.log(this.members);
    }
    else{
      this.buttonDisabled = true;
    }
    
  }

  initDropzone(token: string): void {
    this.dropZone = new Dropzone(`#${this.fileSelectorEl}`, {
      autoProcessQueue: true, // if false, call this.dropZone.processQueue()
      autoDiscover: false,
      acceptedFiles: this.acceptedFileTypes,
      previewTemplate: dropzonePreviewTemplate,
      thumbnailWidth: 204,
      thumbnailHeight: 204,
      maxFilesize: 200,
      url: API_PATH.UPLOAD_RESOURCE,
      headers: {
        Authorization: `Bearer ${token}`
      },
    }).on('thumbnail', (file: any) => {
      $(file.previewElement).addClass('has-thumbnail');
    }).on('success', (file: any, response: any) => {
      if (!this.savedResources || this.savedResources?.length) {
        this.savedResources = [];
      }
      this.savedResources.push({resource_id: response, file: file?.upload?.uuid});
    }).on('removedfile', (file: any) => {
      const deletedFile = this.savedResources.find((item: any) => item.file === file?.upload?.uuid);
      if (deletedFile) {
        this.savedResources = this.savedResources.filter(item => item.file !== file?.upload?.uuid);
        this.removeFile(deletedFile.resource_id);
      }
    }).on('error', (file: any, response: any) => {
      if (response?.indexOf('401') !== -1) {
        this.router.navigate([RouterLinks.Login], {queryParams: {returnUrl: this.router.routerState.snapshot.url}});
      }
    });

    if (this.question?.comment_files) {
      const response = JSON.parse(this.question?.comment_files);

      response.forEach((res: any) => {
        const resource_id = res.resource_id;
        const mockFile = {
          name: resource_id,
          size: 12345
        };
        this.dropZone.emit('addedfile', mockFile);
        this.dropZone.emit('thumbnail', mockFile, `${API_PATH.UPLOAD_RESOURCE}/${resource_id}`);
        this.dropZone.emit('success', mockFile, resource_id);
      });

    }
  }

  removeFile(resource_id: string): void {
    this.questionService.removeFile(resource_id);
  }
  
  addAnother(): void {
    let member = {
      item_id: this.item_id++,
      name: 'Add member',
      questions: this.questions
    }
    this.members.push(member);
  }
  removeMember(i: number): void {
    this.members.splice(i, 1);
  }
  deleteNote(): void {
    this.question.comment = '';
    /*this.question.note_files = '';*/
    this.noteChanged.emit(this.question);
    $('#question-add-note__modal').modal('hide');
  }

  addItem(): void {
    this.componentsService.setMiniFormQuestion(this.questions);
  }
  saveValue(event: any): void {
    
    this.questions.forEach(q => {
      if (q.cent_aq_question_id === event.cent_aq_question_id) {
        if (q.cent_aq_question_id === 2508) {
          q.answer = this.coverOptions.find(o => o.rate_id == event.answer).si;
        }
        else {
          q.answer = event.answer;
        }
        
      }
    });
    
    const allAnswered = this.questions.every(question => question.answer && question.answer !== '' && question.question_id !== 4482);
    if (allAnswered) {
      this.questionService.saveAnswersOnly(this.questions);
      this.question.answer = 'Member added';
      this.questionAnswer.emit(this.question);
    }
  }
  getAge(birthdate: string): number {
    const birth = new Date(birthdate);
    const today = new Date();

    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    const dayDiff = today.getDate() - birth.getDate();

    // Adjust if birthday hasn't occurred yet this year
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    return age;
  }
  setCoverOptions(event: any): void {
    let age = this.getAge(this.getQuestion(2506)?.answer);
    let rates = [];
    
    if (event.answer === 'Spouse')
      rates = this.coverOptions.filter(o => o.rate_type === event.answer && o.min_age <= age && o.max_age >= age);
    else 
      rates = this.coverOptions.filter(o => o.rate_type === event.answer && o.policyholder_si == this.policyHolderSI && o.min_age <= age && o.max_age >= age);

     this.filteredOptions= rates.map(rate => ({
      rate_id: rate.rate_id,
      rate_name: rate.si
    }));

   // setTimeout(() => {
      this.selectedOption = this.filteredOptions.find(o => o.rate_name == this.getQuestion(2508)?.answer)?.rate_id;
    //}, 1000);
    
    
    
  }
  

}
